<template>
    <div>
        <!-- <h5>Relationships</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>Name:</b-th>
                    <b-th>Type:</b-th>
                    <b-th>Address:</b-th>
                    <b-th>Phone:</b-th>
                    <b-th>Email:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr
                    v-for="(relationship, i) in relationships"
                    :key="relationship.id + i"
                >
                    <b-td>
                        <!-- ASSUMING only contact and patient can be in this relationship-->
                        <patient-name
                            v-if="relationship.entity_type === 'patient'"
                            :text="getPatientName(relationship)"
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :patient="relationship"
                        />
                        <contact-name
                            v-else
                            :contact="relationship"
                            :text="relationship.name"
                            :type="relationship.entity_type"
                            :key="relationship.id"
                        ></contact-name>
                        <input
                            type="hidden"
                            name="id"
                            :value="relationship.id"
                        />
                    </b-td>
                    <b-td class="text-capitalize">
                        {{ relationship.type2 }}
                    </b-td>
                    <b-td> {{ getAddress(relationship) }} </b-td>
                    <b-td>
                        <a
                            v-if="relationship.entity_type === 'business'"
                            :href="
                                'tel:' +
                                relationship.phone_country_code +
                                ' ' +
                                relationship.phone
                            "
                            data-rel="external"
                            >{{ relationship.phone }}
                        </a>
                        <a
                            v-else-if="relationship.entity_type === 'actor'"
                            :href="
                                'tel:' +
                                relationship.work_country_code +
                                ' ' +
                                relationship.work
                            "
                            data-rel="external"
                            >{{ relationship.work }}
                        </a>
                    </b-td>
                    <b-td> {{ relationship.email }} </b-td>

                    <b-td class="text-right">
                        <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                            v-if="
                                _hasAccess('contact.company.person.add') ||
                                _hasAccess('contact.company.person.remove')
                            "
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item
                                href="#"
                                @click="showEdit(relationship)"
                                v-if="_hasAccess('contact.company.person.add')"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Relationship
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="#"
                                @click="confirmDelete(relationship)"
                                v-if="
                                    _hasAccess('contact.company.person.remove')
                                "
                            >
                                <i class="cus-delete"></i>
                                Delete Relationship
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="relationships.length === 0">
                    <b-td colspan="8">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />
        <modal-delete
            modal-id="confirm-delete-modal"
            ref="modalDelete"
            @succeed="getList()"
        />

        <modal-edit ref="modalEdit" @success="getList()" />
    </div>
</template>
<script>
import Loader from "@/components/elements/loader-list";
import ModalEdit from "@/components/contact-relationships/relationship-save";
import ModalDelete from "@/components/contact-relationships/relationship-delete-modal";
import PatientName from "@/components/commons/patient-name";
import ContactName from "@/components/commons/contact-name";
import Relationships from "@/services/contact-relationships";

import { without } from "lodash";

export default {
    components: {
        Loader,
        ModalEdit,
        ModalDelete,
        PatientName,
        ContactName
    },
    data() {
        return {
            relationships: [],
            isLoading: false,
            canRemove: false,
            selectedRelation: null,
            meta: null
        };
    },
    computed: {
        contactData() {
            return this.$store.getters["contact/contactDetails"];
        },
        isCompany() {
            return this.$route.name === "contact_company";
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(page) {
            this.isLoading = true;
            this.relationships = [];

            if (this.isCompany) {
                this.getCompanyRelationship(page);
            } else {
                this.getContactRelationship(page);
            }
        },
        getContactRelationship(page) {
            Relationships.getContactRelationship(this.contactData.id, {
                contact_id: this.contactData.id,
                page: page ? page : 1,
                perPage: this.PER_PAGE
            })
                .then(response => {
                    if (response.message.code == 200) {
                        this.relationships = response.resources;
                        this.meta = response.meta;
                        this.isLoading = false;
                    } else {
                        this.showError();
                    }
                })
                .catch(error => {
                    this.showError();
                    console.error(error);
                })
                .finally(() => (this.isLoading = false));
        },
        getCompanyRelationship(page) {
            Relationships.getCompanyRelationship(this.contactData.id, {
                contact_id: this.contactData.id,
                page: page ? page : 1,
                perPage: this.PER_PAGE
            })
                .then(response => {
                    if (response.message.code == 200) {
                        this.relationships = response.resources;
                        this.meta = response.meta;
                        this.isLoading = false;
                    } else {
                        this.showError();
                    }
                })
                .catch(error => {
                    this.showError();
                    console.error(error);
                })
                .finally(() => (this.isLoading = false));
        },
        showError() {
            this._message("Error : Unable to get relationship list", "danger");
            this.isLoading = false;
        },
        getAddress(details) {
            let address = [
                details.address,
                details.city,
                details.state,
                details.zipcode
            ];

            address = without(address, undefined, null, "");

            return address.join(", ");
        },
        getPatientName(details) {
            let name = details.name;

            if (details.primary_owner && details.primary_owner.length > 0) {
                name = name + " " + details.primary_owner[0].lastname;
            }

            return name;
        },
        confirmDelete(relation) {
            this.$refs.modalDelete.open(relation);
        },
        showEdit(relation) {
            this.$refs.modalEdit.open(relation);
        }
    }
};
</script>
